import React, { ChangeEvent, useState } from 'react'
import { observer } from 'mobx-react-lite'

import { CircularProgress, TableCell } from '@material-ui/core'

import { IOSSwitch } from './IOSSwitch'

import { useLogic } from '../hooks/storeHook'
import { useMessages } from '../hooks/snackbarHooks'

import { MyRowProps } from '../types/tableTypes'
import { UserModel } from '../server/mpsklad_core/Models/UserModel'

export const FakeApiCell =
  observer(
    ({row}: MyRowProps<UserModel>) => {
      const {setFakeApiFlag} = useLogic()

      const {showError} = useMessages()

      const [isLoading, setIsLoading] = useState(false)

      const onChange =
        async ({target: {checked: useFakeApi}}: ChangeEvent<HTMLInputElement>) => {
          setIsLoading(true)

          try {
            await setFakeApiFlag(row.id, useFakeApi)
          } catch (e) {
            console.log('Failed to toggle user fake api flag', e)
            showError('Ошибка при сохранении')
          } finally {
            setIsLoading(false)
          }
        }

      return (
        <TableCell className="table-border">
          {
            isLoading
            ? <CircularProgress size={31}/>
            : <IOSSwitch checked={row.isUsingFakeApi} onChange={onChange}/>
          }
        </TableCell>
      )
    })